import { useTranslation } from "@impero-com/common/utils/i18n";
import { Anchor } from "@impero-com/ui";

export const TESTING_PROGRAM_DETAILS_ANCHOR = "testing-program-details";
export const TESTING_PROGRAM_ACCESS_RIGHTS_ANCHOR =
    "testing-program-access-rights";
export const TESTING_PROGRAM_TASKS_ANCHOR = "testing-program-tasks";

// The order MATTERS
export const TESTING_PROGRAM_ANCHORS = [
    TESTING_PROGRAM_DETAILS_ANCHOR,
    TESTING_PROGRAM_ACCESS_RIGHTS_ANCHOR,
    TESTING_PROGRAM_TASKS_ANCHOR,
] as const;

export type TestingProgramAnchor = (typeof TESTING_PROGRAM_ANCHORS)[number];

export function useTestingProgramViewAnchorLabels(): Record<
    TestingProgramAnchor,
    string
> {
    const { t } = useTranslation();
    return {
        [TESTING_PROGRAM_DETAILS_ANCHOR]: t("TestingProgramView_Details_Title"),
        [TESTING_PROGRAM_ACCESS_RIGHTS_ANCHOR]: t(
            "TestingProgramView_AccessRights_Title"
        ),
        [TESTING_PROGRAM_TASKS_ANCHOR]: t("TestingProgramView_Tasks_Title"),
    };
}

export function useTestingProgramViewAnchors(): Anchor[] {
    const anchorLabels = useTestingProgramViewAnchorLabels();
    return TESTING_PROGRAM_ANCHORS.map((anchor) => ({
        elementId: anchor,
        label: anchorLabels[anchor],
    }));
}
